import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import ar from "./locales/ar.json";
import de from "./locales/de.json";
import es from "./locales/es.json";
import fr from "./locales/fr.json";

export const SUPPORTED_LANGS = [
  { code: "en", label: "English", native: "English", dir: "ltr", flag: "🇬🇧" },
  { code: "ar", label: "Arabic",  native: "العربية", dir: "rtl", flag: "🇯🇴" },
  { code: "de", label: "German",  native: "Deutsch", dir: "ltr", flag: "🇩🇪" },
  { code: "es", label: "Spanish", native: "Español", dir: "ltr", flag: "🇪🇸" },
  { code: "fr", label: "French",  native: "Français", dir: "ltr", flag: "🇫🇷" },
];

const STORAGE_KEY = "iyaf_lang";
const stored = typeof window !== "undefined" ? window.localStorage.getItem(STORAGE_KEY) : null;
const initial = SUPPORTED_LANGS.some((l) => l.code === stored) ? stored : "en";

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    ar: { translation: ar },
    de: { translation: de },
    es: { translation: es },
    fr: { translation: fr },
  },
  lng: initial,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  returnEmptyString: false,
});

export function applyLangSideEffects(code) {
  const lang = SUPPORTED_LANGS.find((l) => l.code === code) || SUPPORTED_LANGS[0];
  if (typeof document !== "undefined") {
    document.documentElement.lang = lang.code;
    document.documentElement.dir = lang.dir;
  }
}

export function setLanguage(code) {
  if (!SUPPORTED_LANGS.some((l) => l.code === code)) return;
  window.localStorage.setItem(STORAGE_KEY, code);
  i18n.changeLanguage(code);
  applyLangSideEffects(code);
}

// Apply on initial load
applyLangSideEffects(initial);

export default i18n;
